import React, { useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";

const RunnerFilterDropDown = ({
  label,
  stateValue,
  options,
  onChange,
  isHidden = false,
}) => {
  const [isOpenDropDown, setIsOpenDropDown] = useState(false);
  return (
    !isHidden && (
      <Dropdown
        isOpen={isOpenDropDown}
        toggle={() => setIsOpenDropDown(prev => !prev)}
      >
        <DropdownToggle className="btn primary-btn w-100" caret>
          {label}
          {stateValue?.label && <span>:&nbsp;{stateValue?.label}</span>}
          <i className="mdi mdi-chevron-down" />
        </DropdownToggle>
        <DropdownMenu className="w-100">
          {options?.length > 0 &&
            options.map((item, index) => (
              <DropdownItem
                key={`runner-${index}`}
                onClick={() => onChange(item)}
                active={item.value === stateValue?.value}
              >
                {item.label}
              </DropdownItem>
            ))}
        </DropdownMenu>
      </Dropdown>
    )
  );
};

export default RunnerFilterDropDown;
